import { inIframe } from '../../utils/inIframe';

export const canMakePaymentsStrategy = (): Promise<boolean> => {
  if (!inIframe()) {
    return Promise.resolve(checkCanMakePayments());
  }
  if (!window.Wix) {
    return Promise.resolve(false);
  }
  return checkCanMakePaymentsJsSdk();
};

const checkCanMakePayments = (): boolean => {
  return Boolean(window.ApplePaySession?.canMakePayments());
};

const checkCanMakePaymentsJsSdk = (): Promise<boolean> => {
  return new Promise<boolean>((res, rej) => {
    window.Wix.Pay.ApplePay.invokeMethod(
      'canMakePayments',
      null,
      (r) => {
        res(r.result);
      },
      (e) => {
        rej(e);
      },
    );
  });
};
